import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export const convertTimeStringFromUTC = (timeStr) => {
    if (!timeStr) return timeStr;
    const [hours, minutes] = timeStr.split(":");
    return dayjs
        .utc()
        .set("hour", parseInt(hours))
        .set("minute", parseInt(minutes))
        .set("second", 0)
        .local()
        .format("h:mm A");
};

export const isUpcoming = (date) => dayjs(date).isAfter(dayjs());

export const getTimeUntil = (date) => {
    const now = dayjs();
    const target = dayjs.utc(date).local();
    const hours = target.diff(now, "hour");

    if (hours < 1 && hours > 0) {
        return `in ${target.diff(now, "minute")}m`;
    }
    if (hours < 24 && hours >= 0) {
        return `in ${hours}h`;
    }
    return target.fromNow();
};
